import { serializeNotesDoc } from './notesEditorExtensions';

export const NOTES_TAB_COLORS = ['#111111', '#3ba378', '#0a59f0', '#c0392b', '#7c6cdd'];

export const NOTES_FORMAT_ACTIONS = [
  { id: 'bold', label: 'B', title: 'Bold' },
  { id: 'bullet', label: 'List', title: 'Bullet list' },
  { id: 'divider', label: '—', title: 'Divider' },
  { id: 'alignLeft', label: 'Left', title: 'Align left' },
  { id: 'alignCenter', label: 'Center', title: 'Align center' },
  { id: 'alignRight', label: 'Right', title: 'Align right' },
];

function emitNotesHtml(editor, onChange) {
  onChange?.(serializeNotesDoc(editor));
}

export function runNotesFormatCommand(editor, action, onChange) {
  if (!editor) return;
  const chain = editor.chain().focus();

  switch (action.id) {
    case 'bold':
      chain.toggleBold();
      break;
    case 'bullet':
      chain.toggleBulletList();
      break;
    case 'divider':
      chain.setHorizontalRule();
      break;
    case 'alignLeft':
      chain.setTextAlign('left');
      break;
    case 'alignCenter':
      chain.setTextAlign('center');
      break;
    case 'alignRight':
      chain.setTextAlign('right');
      break;
    case 'color': {
      const hex = String(action.hex || '').trim();
      if (!hex) return;
      chain.setColor(hex);
      break;
    }
    default:
      return;
  }

  chain.run();
  emitNotesHtml(editor, onChange);
}
